import { motion } from "framer-motion";
import { PuzzlePiece, Sparkle } from "@phosphor-icons/react";
import { Mascot } from "../styleguide/Mascot";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export function LibraryHero() {
  return (
    <section className="relative overflow-hidden">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-teal/15 blur-3xl" />
        <div className="absolute right-0 top-10 h-56 w-56 rounded-full bg-primary/20 blur-3xl" />
      </div>

      <div className="relative mx-auto grid w-full max-w-content items-center gap-10 px-5 py-14 sm:px-8 md:py-20 lg:grid-cols-[1.2fr_0.8fr] lg:px-12">
        <div>
          <motion.span
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 rounded-full bg-accent px-4 py-1.5 text-sm font-bold uppercase tracking-wider text-accent-foreground"
          >
            <PuzzlePiece size={16} weight="fill" /> Component Library
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}
            className="mt-5 font-display text-4xl font-black leading-[1.05] tracking-tight text-balance md:text-5xl"
          >
            Building blocks that <span className="text-primary-strong">grow with every child.</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.12 }}
            className="mt-5 max-w-xl text-lg font-medium leading-relaxed text-muted-foreground"
          >
            A warm, accessible, reusable kit — navigation, cards, questions, rewards, feedback and motion — ready to assemble into 50–100 screens, all built on the Bloom foundations.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.18 }}
            className="mt-7 flex flex-wrap gap-3"
          >
            <button onClick={() => scrollTo("questions")} className="inline-flex min-h-[52px] items-center gap-2 rounded-full bg-primary px-7 font-display font-bold text-primary-foreground shadow-glow transition-all duration-200 ease-bounce hover:-translate-y-0.5 active:scale-95" data-testid="lib-hero-questions">
              <Sparkle size={20} weight="fill" /> See question components
            </button>
            <button onClick={() => scrollTo("cards")} className="inline-flex min-h-[52px] items-center rounded-full border-2 border-border px-7 font-display font-bold text-foreground transition-all hover:border-primary hover:text-primary-strong" data-testid="lib-hero-cards">
              Browse cards
            </button>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.34, 1.56, 0.64, 1], delay: 0.1 }}
          className="relative mx-auto flex w-full max-w-xs items-center justify-center"
        >
          <div className="rounded-[2.5rem] border border-border bg-card p-10 shadow-soft-lg">
            <Mascot size={170} mood="happy" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default LibraryHero;
